import { JsonError } from '@sagold/react-json-editor';
import clsx from 'clsx';

import styles from './formfield.module.scss';

export type FormErrorProps = {
  errors: JsonError[];
  tableLayout?: boolean;
};

export function FormError({ errors, tableLayout }: FormErrorProps) {
  if (errors.length === 0) {
    return null;
  }
  return (
    <div
      className={clsx('rje-error', {
        [styles['form-error--table-layout']]: tableLayout,
      })}
    >
      <span className="rje-icon rje-icon--solid rje-icon--error">Report</span>
      {errors.map((e) => e.message).join(';')}
    </div>
  );
}
